export const PREPOST_TENNESSEE_PRACTICE = 'PrePost+Tennessee';

export const PREPOST_PRACTICE_OPTIONS = [
  {
    value: PREPOST_TENNESSEE_PRACTICE,
    label: PREPOST_TENNESSEE_PRACTICE,
  },
];
